import BusinessIcon from "@mui/icons-material/Business";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const getIcon = (label: string) => {
    if (label.includes("contractors")) return <BusinessIcon fontSize="large" />;
    if (label.includes("projects")) return <AccountTreeIcon fontSize="large" />;
    if (label.includes("activities")) return <AssignmentIcon fontSize="large" />;
    if (label.includes("delivery")) return <CheckCircleIcon fontSize="large" />;
    return <BusinessIcon fontSize="large" />;
};